import React from "react";
import { safeBuilderHtml } from "~/lib/builder-utils";
import { cn } from "../../lib/cn";

interface ProseProps {
  size?: "lg" | "xl";
  content: unknown;
}

export const Prose = ({ content, size }: ProseProps) => {
  const htmlContent = safeBuilderHtml(content);

  const sizeClasses = {
    lg: "prose-lg",
    xl: "prose-xl",
  };

  return (
    <div
      className={cn(
        "prose prose-gray mx-auto w-full",
        size ? sizeClasses[size] : "",
      )}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    ></div>
  );
};
